module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('section', {
    staticClass: "sp-mini-wrap"
  }, [_c('div', {
    staticClass: "container padding-top-50"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "sp-landing-circle col-md-6 col-md-offset-3 col-sm-12 col-xs-12"
  }, [_c('div', {
    staticClass: "row sp-inner-circle"
  }, [_c('div', {
    staticClass: "logo-image text-center"
  }, [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": "static/assets/images/logo.png",
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "padding-top-20 padding-bottom-20",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "16px",
      "color": "#2d3a4b"
    }
  }, [_vm._v("Prepare and setup your interests, businesses and views for a larger world to connect.")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "font-size": "14px",
      "color": "#f8f9fa",
      "background": "#2d3a4b"
    },
    attrs: {
      "href": "register",
      "type": "button"
    }
  }, [_vm._v("Get Started")])]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    attrs: {
      "tyle": "text-align: center;"
    }
  }, [_c('p', {
    staticClass: "hidden-sm hidden-xs",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Have an Account? "), _c('a', {
    attrs: {
      "href": "login"
    }
  }, [_c('u', [_vm._v("Log In")])]), _c('br'), _vm._v(" Or  "), _c('a', {
    attrs: {
      "href": "register"
    }
  }, [_c('u', [_vm._v("Create an Account ")])])]), _vm._v(" "), _c('p', {
    staticClass: "hidden-lg hidden-md",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("Have an Account? "), _c('a', {
    attrs: {
      "href": "login"
    }
  }, [_c('u', [_vm._v("Log In")])]), _vm._v(" Or  "), _c('br'), _c('a', {
    attrs: {
      "href": "register"
    }
  }, [_c('u', [_vm._v("Create an Account ")])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1da44c0c"}!./src/pages/Home/template.html
// module id = 274
// module chunks = 0